import { useCallback, useState } from 'react';

export const useDialogState = (): {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
} => {
  const [open, setOpen] = useState<boolean>(false);

  const openDialog = useCallback(() => setOpen(true), [setOpen]);
  const closeDialog = useCallback(() => setOpen(false), [setOpen]);

  return { open, openDialog, closeDialog };
};
